import apiClient from "@/api/apiClient";
import { type ChecklistTemplate } from "@/supabase.types";
import { spawnCreateApiFunction, spawnUpdateApiFunction, type ApiResourceConfig } from "@/utils/api";

const table = "checklist_templates";
const query = `
        *,
        shared_to:workspaces!checklist_templates_to_workspaces(id)
      `;
const queryShared = `
        *,
        shared_to:workspaces!checklist_templates_to_workspaces(id),
        checklist_templates_to_workspaces!inner(workspace_id)
      `;

export const apiConfigChecklistTemplates: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["title", "description"],
  sortables: ["created_at", "updated_at", "title", "is_public"],
};

export const createChecklistTemplate = spawnCreateApiFunction({ table, query });
export const updateChecklistTemplate = spawnUpdateApiFunction({ table, query });

export async function getChecklistTemplate(match: Partial<ChecklistTemplate>) {
  const { data, error } = await apiClient.from(table).select(query).match(match).eq("is_deleted", false).maybeSingle();
  if (error) throw error;
  return data;
}

export const deleteChecklistTemplate = async (match: Partial<ChecklistTemplate>) => {
  const { error, ...rest } = await apiClient.from(table).update({ is_deleted: true }).match(match);
  if (error) throw error;

  return { error, ...rest };
};

export const getChecklistTemplates = async (workspace_id: string) => {
  const { data, error } = await apiClient
    .from(table)
    .select(query)
    .eq("is_deleted", false)
    .eq("workspace_id", workspace_id);

  if (error) throw error;
  return data;
};

export const getSharedChecklistTemplates = async (workspace_id: string) => {
  const { data, error } = await apiClient
    .from(table)
    .select(queryShared)
    .eq("is_deleted", false)
    .eq("checklist_templates_to_workspaces.workspace_id", workspace_id);

  if (error) throw error;
  return data;
};

export const getPublicChecklistTemplates = async (workspace_id: string) => {
  const { data, error } = await apiClient
    .from(table)
    .select(query)
    .eq("is_deleted", false)
    .eq("is_public", true)
    .neq("workspace_id", workspace_id);

  if (error) throw error;
  return data;
};
